import { Usecase } from '.'

export class FixNetworkIssueUsecase extends Usecase {
    invoke (): void {
        this.browserService.reload()
    }
}
